export const cardData = [
  {
    id: 1,
    title: "#Bollywood",
    body:
      "The heart of the Hindi film industry, Mumbai is home to the biggest studios and the biggest names in bollywood.",
    img:
      "https://i.pinimg.com/originals/b6/82/52/b6825255beba29b11155b5d6218d86db.png"
  },
  {
    id: 2,
    title: "#Food",
    body:
      "Pioneering several world famous street food delicacies, Mumbai has a plethora of cuisines from around the world. Bhelpuri, anyone?",
    img:
      "https://i1.wp.com/roadsandkingdoms.com/uploads/2018/03/3-Bombay-Bhelpuri-7.jpg?ssl=1&w=680&quality=95&strip=color"
  },
  {
    id: 3,
    title: "#Local-Train",
    body:
      "The respiratory system of the city, Mumbai never sleeps as long as the railways are open for business.",
    img:
      "https://www.thebetterindia.com/wp-content/uploads/2019/02/Mumbai-Local-1234.jpg"
  },
  {
    id: 4,
    title: "#Sea",
    body:
      "Mumbai has some really famous beaches in India. A visit to Juhu beach and a plate of pav bhaji makes for an awesome evening!",
    img:
      "https://cdn.dnaindia.com/sites/default/files/styles/full/public/2019/04/29/817937-juhu-beach-dna.jpg"
  },
  {
    id: 5,
    title: "#Shopping",
    body:
      "A visit to hill road in Bandra or Colaba causeway are the goto shopping destinations for street markets. Foreigners beware!",
    img:
      "https://static-blog.treebo.com/wp-content/uploads/2018/03/On-Hill-Road-you%E2%80%99ll-find-a-number-of-clothes-and-accessory-options-.jpg"
  },
  {
    id: 6,
    title: "#History",
    body:
      "Mumbai is home to several monuments and heritage buildings worth visiting. Visit the Gateway of India, Haji Ali Dargah and The Taj to whet your tourist appetite!",
    img:
      "https://static-blog.treebo.com/wp-content/uploads/2018/03/The-Gateway-sees-hundreds-of-visitors-a-day-.jpg"
  }
];
